/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { JobRestService, PriceBookRestService, PriceBookUsage } from '@gh/builder-shared-data';
import { AutocompleteItem } from '@gh/common-shared-data';
import { FilteredDataQuery, getSlicedData } from '@gh/core-data';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import { JobRedoDetails } from './job-redo.model';

@Injectable()
export class JobRedoBusinessService {
  constructor(private restService: JobRestService,
              private priceBookRest: PriceBookRestService) {

  }

  findPriceBooksByName(query: FilteredDataQuery<string>): Observable<AutocompleteItem[]> {
    return this.priceBookRest.findAllAsAutocompleteDataSource({
      searchString: query.filter,
      usage: [PriceBookUsage.Normal],
    }).select(query).pipe(map$(getSlicedData));
  }

  redo(details: JobRedoDetails, skipConstructionScheduleCheck: boolean = false): Observable<void> {
    return this.restService.redo({
      jobId: details.job.id,
      priceBookId: details.priceBook.id,
      housePlanId: details.housePlan.housePlanId,
      version: details.job.version!, // tslint:disable-line:no-non-null-assertion
      confirmations: { skipConstructionScheduleCheck },
    });
  }
}
